export type FinalEstimateReview = {
  orderId: string;
  orderNo: string;
  estimateNo: string;
  /** ISO time the estimate expires; the queue is ordered by it. */
  expiryTime?: string;
};

const expiryOf = (review: FinalEstimateReview) => {
  const time = review.expiryTime ? Date.parse(review.expiryTime) : NaN;
  return Number.isNaN(time) ? Infinity : time;
};

/**
 * Adds a review to the queue, soonest-expiring first (one without an expiry
 * goes last), unless that estimate is on screen. One already queued (the feed
 * and the pending list can both bring it) only takes the expiry it was missing.
 */
export function enqueueFinalEstimateReview(
  queue: FinalEstimateReview[],
  activeEstimateNo: string | null | undefined,
  review: FinalEstimateReview,
): FinalEstimateReview[] {
  if (!review.estimateNo || review.estimateNo === activeEstimateNo) {
    return queue;
  }
  const queued = queue.find(
    (candidate) => candidate.estimateNo === review.estimateNo,
  );
  if (queued && (queued.expiryTime || !review.expiryTime)) {
    return queue;
  }
  const rest = queue.filter((candidate) => candidate !== queued);
  const index = rest.findIndex(
    (candidate) => expiryOf(candidate) > expiryOf(review),
  );
  return index === -1
    ? [...rest, review]
    : [...rest.slice(0, index), review, ...rest.slice(index)];
}
